{
  "partners_page": {
    "header": {
      "title": "Partner Integrations",
      "description": "Activate and configure approved SparkLayer partner integrations.",
      "footer": "Learn more about partner integrations"
    },
    "modify": "Modify",
    "coming_soon": "(Coming soon)",
    "logo_alt": "{partner} logo",
    "groups": {
      "orders": {
        "title": "Multi-channel management",
        "description": "Ensure data is synchronised across your business systems"
      },
      "accountancy": {
        "title": "Accountancy",
        "description": "Integration with accountancy partners"
      },
      "invoicing": {
        "title": "Invoicing",
        "description": "Integrate with invoicing partners"
      },
      "shipping": {
        "title": "Shipping",
        "description": "Integrate with shipping partners"
      }
    },
    "partners": {
      "linnworks": {
        "name": "Linnworks",
        "description": "Connect to Linnworks to synchronise pricing and use our macros to synchronise orders."
      },
      "brightpearl": {
        "name": "Brightpearl",
        "description": "Connect to Brightpearl to synchronise customers, addresses and pricing."
      },
      "unleashed": {
        "name": "Unleashed",
        "description": "Connect to Unleashed to synchronise customers, addresses and pricing."
      },
      "cin7": {
        "name": "Cin7 Core",
        "description": "Connect to Cin7 Core to synchronise customers, addresses and pricing."
      },
      "katana": {
        "name": "Katana",
        "description": "Connect to Katana to synchronise customers, addresses and pricing."
      },
      "xero": {
        "name": "Xero",
        "description": "Connect to Xero to synchronise your payment statuses and invoices."
      },
      "quickbooks": {
        "name": "QuickBooks",
        "description": "Connect to QuickBooks to synchronise your payment statuses and invoices."
      },
      "sufio": {
        "name": "Sufio",
        "description": "Let your B2B customers view and download their invoices using Sufio."
      },
      "intuitive_shipping": {
        "name": "Intuitive Shipping",
        "description": "Configure your Intuitive Shipping integration."
      }
    },
    "upsell": {
      "available_on": "Available on Pro & Enterprise",
      "change_plan": "Change plan"
    },
    "beta": {
      "join": "Join the early-access beta",
      "sign_up": "Sign up here"
    }
  },
  "oauth_callback": {
    "description": "Finishing the connection between SparkLayer and your partner account.",
    "connecting": "We're connecting to {partner}… please wait…",
    "success": "Accounts are now connected, please now enable the partner integration.",
    "state_mismatch": "OAuth state did not match, please contact support.",
    "error": "Something went wrong, please contact support."
  }
}
